import { render, staticRenderFns } from "./ContactSearchFacets.vue?vue&type=template&id=4e0570d2"
import script from "./ContactSearchFacets.vue?vue&type=script&lang=js"
export * from "./ContactSearchFacets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports